@file:OptIn(InternalResourceApi::class)

package portalvv.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/portalvv.shared.generated.resources/"

@delegate:ResourceContentHash(1_380_396_788)
internal val Res.drawable.logo_portal: DrawableResource by lazy {
      DrawableResource("drawable:logo_portal", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_portal.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_410_865_939)
internal val Res.drawable.logo_vv: DrawableResource by lazy {
      DrawableResource("drawable:logo_vv", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_vv.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_000_983_582)
internal val Res.drawable.undrawable_authentication: DrawableResource by lazy {
      DrawableResource("drawable:undrawable_authentication", setOf(
        ResourceItem(setOf(), "${MD}drawable/undrawable_authentication.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_408_518_148)
internal val Res.drawable.undrawable_empty: DrawableResource by lazy {
      DrawableResource("drawable:undrawable_empty", setOf(
        ResourceItem(setOf(), "${MD}drawable/undrawable_empty.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(423_198_194)
internal val Res.drawable.undrawable_forgot_password: DrawableResource by lazy {
      DrawableResource("drawable:undrawable_forgot_password", setOf(
        ResourceItem(setOf(), "${MD}drawable/undrawable_forgot_password.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_141_002_154)
internal val Res.drawable.undrawable_happy_news: DrawableResource by lazy {
      DrawableResource("drawable:undrawable_happy_news", setOf(
        ResourceItem(setOf(), "${MD}drawable/undrawable_happy_news.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_420_559_435)
internal val Res.drawable.undrawable_lost_trip: DrawableResource by lazy {
      DrawableResource("drawable:undrawable_lost_trip", setOf(
        ResourceItem(setOf(), "${MD}drawable/undrawable_lost_trip.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_016_098_690)
internal val Res.drawable.undrawable_maintenance: DrawableResource by lazy {
      DrawableResource("drawable:undrawable_maintenance", setOf(
        ResourceItem(setOf(), "${MD}drawable/undrawable_maintenance.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(847_582_088)
internal val Res.drawable.undrawable_secure_password: DrawableResource by lazy {
      DrawableResource("drawable:undrawable_secure_password", setOf(
        ResourceItem(setOf(), "${MD}drawable/undrawable_secure_password.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-424_236_534)
internal val Res.drawable.undrawable_system_interface: DrawableResource by lazy {
      DrawableResource("drawable:undrawable_system_interface", setOf(
        ResourceItem(setOf(), "${MD}drawable/undrawable_system_interface.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-220_286_063)
internal val Res.drawable.undrawable_to_do_list: DrawableResource by lazy {
      DrawableResource("drawable:undrawable_to_do_list", setOf(
        ResourceItem(setOf(), "${MD}drawable/undrawable_to_do_list.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-624_050_790)
internal val Res.drawable.undrawable_under_construction: DrawableResource by lazy {
      DrawableResource("drawable:undrawable_under_construction", setOf(
        ResourceItem(setOf(), "${MD}drawable/undrawable_under_construction.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_186_647_591)
internal val Res.drawable.undrawable_welcome_aboard: DrawableResource by lazy {
      DrawableResource("drawable:undrawable_welcome_aboard", setOf(
        ResourceItem(setOf(), "${MD}drawable/undrawable_welcome_aboard.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("logo_portal", Res.drawable.logo_portal)
  map.put("logo_vv", Res.drawable.logo_vv)
  map.put("undrawable_authentication", Res.drawable.undrawable_authentication)
  map.put("undrawable_empty", Res.drawable.undrawable_empty)
  map.put("undrawable_forgot_password", Res.drawable.undrawable_forgot_password)
  map.put("undrawable_happy_news", Res.drawable.undrawable_happy_news)
  map.put("undrawable_lost_trip", Res.drawable.undrawable_lost_trip)
  map.put("undrawable_maintenance", Res.drawable.undrawable_maintenance)
  map.put("undrawable_secure_password", Res.drawable.undrawable_secure_password)
  map.put("undrawable_system_interface", Res.drawable.undrawable_system_interface)
  map.put("undrawable_to_do_list", Res.drawable.undrawable_to_do_list)
  map.put("undrawable_under_construction", Res.drawable.undrawable_under_construction)
  map.put("undrawable_welcome_aboard", Res.drawable.undrawable_welcome_aboard)
}
